import React, { useState } from "react";
import { Field } from "redux-form";
import { createNumberMask, createTextMask } from 'redux-form-input-masks';
import EyeIcon from "../icons/eyeIcon"

//TODO: Alterar para ficar com estilo definido no prototipo
export default props => {

      const mask=() =>{
          if(props.mask && props.mask==='date'){
              return(
                createTextMask({
                    pattern: '99/99/9999',
                    guide:false
                  })
              )
          
          } else if(props.mask && props.mask==='phone'){
              return(
                  createTextMask({
                      pattern: '(99) 99999 - 9999',
                      guide:false
                  })
              )
          }
       
      }

    const [visible, setVisible] = useState(false);

    function switchVisibility() {
        if (props.type === "password") {
            setVisible(!visible)
        }
    }

    function defineType() {
        if (props.type === "password" && !visible) {
            return "password";
        } else if (props.type === "password" && visible) {
            return "text";
        } else {
            return props.type
        }
    }

    return (
        
        <div style={props.style}>
            <div className={`account-input-container ${props.hasError ? "error" : " "}`}>
                <label htmlFor={props.name} className={"account-input-label"}>{props.labelText}</label>

                <Field name={props.name} component={"input"} type={defineType()} className={"account-input"}
                    placeholder={`${props.label}`} {...mask()} onChange={props.onChange} />

                {props.type === "password" ?
                    <span className={"account-eye-span"}>
                        <a onClick={() => switchVisibility()} ><EyeIcon className={"account-eye"} /></a>
                    </span> : null}

            </div>

            <span className={`span-display ${props.hasError ? "span-display-block" : " "}`}>{props.hasError ? props.error : " "}</span>
        </div>
    )


  
    
}